import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { bimSetActKC2OtherCostCommentGql } from '../bimWorkOrderOthersQueries';

const requestBaseId = 'bimSetActKC2OtherCostComment';

export const useSetActKC2OtherCostComment = (
    workOrderOtherPriceId: number,
    actKC2OtherId: number,
    onUpdateFinish: () => void,
) => {
    const dispatch = useDispatch();

    const requestDynamicPartId = `${workOrderOtherPriceId}_${actKC2OtherId}`;
    const requestId = `${requestBaseId}_${requestDynamicPartId}`;

    const [bimSetActKC2OtherCostReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        bimSetActKC2OtherCostReset(undefined);
        onUpdateFinish();
    }, [bimSetActKC2OtherCostReset, onUpdateFinish]);

    const [
        ,
        bimSetActKC2OtherCostCommentStatus,
        ,
        bimSetActKC2OtherCostCommentRequest,
        ,
        bimSetActKC2OtherCostCommentAbortRequest,
    ] = useRequest({
        requestId,
        withEffect: false,
        query: bimSetActKC2OtherCostCommentGql,
        dependenciesUpdater: onSuccessLocal,
    });

    const isUpdateInProgress = bimSetActKC2OtherCostCommentStatus === RequestStatus.FETCHING;

    const bimSetActKC2OtherCostCommentMakeRequest = useCallback(
        (comment: string | null | undefined) => {
            if (isUpdateInProgress) {
                dispatch(bimSetActKC2OtherCostCommentAbortRequest(undefined));
            }

            dispatch(bimSetActKC2OtherCostCommentRequest({ comment, workOrderOtherPriceId, actKC2OtherId }));
        },
        [
            actKC2OtherId,
            bimSetActKC2OtherCostCommentAbortRequest,
            bimSetActKC2OtherCostCommentRequest,
            dispatch,
            isUpdateInProgress,
            workOrderOtherPriceId,
        ],
    );

    return { bimSetActKC2OtherCostCommentMakeRequest, requestBaseId, requestDynamicPartId, isUpdateInProgress };
};
